import { FC, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const HeaderBar: FC<PropsWithChildren> = ({ children }) => {
  return <div css={styles.header}>{children}</div>;
};

const styles = {
  header: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing(1, 2)};
  `,
};
